import React from 'react'
import { useDispatch } from 'react-redux'
import { Grid, Typography, Box } from '@material-ui/core'
import InviteButton from 'components/InviteButton'
import useCurrentUserEntity from 'hooks/useCurrentUserEntity'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import useFormExpanded from 'hooks/useFormExpanded'
import { FormProvider } from 'react-hook-form'
import Phone from 'components/Fields/Phone'
import { updateUser } from 'actions/users'
import CongratsLogo from 'img/congrats-logo.svg'

export default function Finish({ completeStep, Footer }) {
  const formMethods = useFormExpanded()
  const { hasErrors, handleSubmit, setFieldValidationErrors } = formMethods
  const { name: communityName } = useCurrentUserEntity('community', 'communities')
  const userId = useCurrentUserProp('id')
  const dispatch = useDispatch()

  function saveAndContinue(values) {
    dispatch(updateUser(userId, values))
    .then(() => {
      completeStep('Finish')
    })
    .catch((errorResponse) => {
      setFieldValidationErrors(errorResponse)
    })
  }

  return (
    <FormProvider { ...formMethods }>
      <Grid container justifyContent='center'>
        <Grid item xs={12} sm={8} md={6} lg={4}>
          <Box textAlign='center'>
            <Box maxWidth='18rem' component='img' alt='congrats logo' src={CongratsLogo} />
            <Typography variant='body2'>
              Fantastic, you’re now all set to be supporting our community at {communityName} in the background of your daily life.
            </Typography>
          </Box>

          <Box textAlign='center' mb={3}>
            <Typography variant='body2'>
              We highly recommend entering your phone number below to get notifications for tithe verifications.
            </Typography>
            <Phone margin='normal' />
          </Box>

          <Box textAlign='center'>
            <Typography variant='body2' gutterBottom>
              Last of all, can you invite one or two other members of our community to this method of tying our lives together financially to help us increase our outpouring of impact and missional community?
            </Typography>
            <InviteButton size='large' variant='contained' color='secondary' />
          </Box>
        </Grid>
      </Grid>
      <Footer
        handleClickNext={handleSubmit(saveAndContinue)}
        disableNextButton={hasErrors}
      />
    </FormProvider>
  )
}
